import React from 'react';
import { HeroSection } from './sections/HeroSection';
import { ProblemSection } from './sections/ProblemSection';
import { RealitySection } from './sections/RealitySection';
import { ExampleSection } from './sections/ExampleSection';
import { SolutionSection } from './sections/SolutionSection';
import { BenefitsSection } from './sections/BenefitsSection';
import { TestimonialsSection } from './sections/TestimonialsSection';
import { UrgencySection } from './sections/UrgencySection';
import { OfferSection } from './sections/OfferSection';
import { FinalCTASection } from './sections/FinalCTASection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="w-full min-h-screen bg-brand-darker font-body" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <RealitySection data-id="element-3" />
      <ExampleSection data-id="element-4" />
      <SolutionSection data-id="element-5" />
      <BenefitsSection data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <UrgencySection data-id="element-8" />
      <OfferSection data-id="element-9" />
      <FinalCTASection data-id="element-10" />
      <SocialProofPopup data-id="element-11" />
    </div>;
}